import { marketLocation, oldMarketLocation } from '@e2m-customer-portal/core';
import { matchPath, useLocation } from 'react-router';

/**
 * Retrieves the market location id from the current route. The market location id may be undefined if the current route is unknown
 * or a route where the market location id is not applicable.
 *
 * @example
 * const marketLocationId = useMarketLocationId();
 * const marketLocation = load(marketLocationId);
 */
export function useMarketLocationId(): string | undefined {
  const { pathname } = useLocation();
  const match =
    matchPath({ path: marketLocation.pattern, end: false }, pathname) ??
    matchPath({ path: oldMarketLocation.pattern, end: false }, pathname);
  return (match?.params as { marketLocationId?: string })?.marketLocationId;
}
